export default __webpack_public_path__ + "static/media/arrow_forward_blue.df74dec0.svg";